import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import WishBar from "./wishCartCompareBar";
import Menu from "./menu";
import Arrow from "../images/chevron_down_icon.png";
import CustomMenu from "./CustomMenu/CustomMenu";
import { Link } from "react-router-dom";
import i18n from "i18next";
import MiddleMenu from "./CustomMenu/middleMenu";
class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = { showCatalog: false };
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  handleCatalog = () => {
    this.setState({ showCatalog: !this.state.showCatalog });
  };
  handleClickOutside(e) {
    if (this.state.showCatalog && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ showCatalog: false});
    }
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUpdate() {
    if (this.state.showCatalog) {
      this.setState({ showCatalog: !this.state.showCatalog });
    }
    
  }
 

  render() {
    const { t } = this.props;

    return (
      <div ref={this.wrapperRef} className="header-nav">
        <div className="uk-container">
          <nav className="uk-flex uk-flex-middle uk-flex-between uk-margin">
            <div className="uk-width-5-6  nav-catalog ">
              <ul className="uk-navbar-nav uk-flex-middle">
                <li className="uk-position-relative">
                  <span
                    className="header__catalog-link"
                    onClick={this.handleCatalog}
                  >
                    {t("menu.catalog")}{" "}
                    <img className="header__catalog-arrow" src={Arrow} />
                  </span>
                  <Menu catalogState={!this.state.showCatalog} />
                </li>
                <CustomMenu />
                {/* <li>
                  <Link
                    className="header-nav__link"
                    to={`/products/${i18n.language}/promo/actions`}
                  >
                    {i18n.t("actions")}
                  </Link>
                </li> */}
                <MiddleMenu />
              </ul>
            </div>
            <div className="uk-width-1-6  uk-flex uk-flex-middle uk-flex-right">
              <WishBar />
            </div>
          </nav>
        </div>
      </div>
    );
  }
}
const NavBar = withTranslation("translations")(Nav);
export default NavBar;
